import React, { Component } from 'react';
import PassAuth from '../components/PassAuth'

import { db, auth } from '../config/fire';
import Roomi from "../components/RoomMain";

import Loader from '../components/Loader';

export default class Redirec extends Component {

    constructor(props) {
        super(props);
        this.state = {

            load: true,
            allowu: [],
            meetname: this.props.title,
            comp: <Loader />,
            allowed: false,
            auth: false,
            roomId: this.props.roomid,
            isallowed: false,
            

        }
        document.title = "Loading..."


    }
    componentDidMount() {
        const roomID = this.state.roomId;
        const cuser = auth().currentUser;
        const cemail = cuser.email;
        const userdb = db().ref('all-rooms/' + this.state.roomId + '/users');

        let allowedd = false;
        userdb.once('value', data => {
            if (data.exists()) {
                this.setState({
                    isallowed: true,
                })
                
                console.log('Roomis Allowed Type')
                data.forEach(function (datas) {
                    const allowe = datas.val();
                    if (allowe.includes(cemail)) {
                        allowedd = true;
                    }
                });

                this.setState({
                    allowed: allowedd
                })
                console.log(allowedd + 'is');


            }
            else {
                console.log('Non-Roomed')
                this.setState({
                    isallowed: false,
                })
            }
        })
        const roomref = db().ref('all-rooms/' + roomID);
        roomref.once('value', snapshot => {
            console.log(snapshot.val());
            const data = snapshot.val();
            this.setState({
                load: false
            })
            console.log(data.auth);
            if (data.auth == true) {
                this.setState({
                    auth: true,
                });

            }
            else {
                this.setState({
                    auth: false,
                })
            }
        });


    }
    render() {
        return (
            this.state.load ? <Loader/>:
                this.state.isallowed ?
                    this.state.allowed ?
                        this.state.auth ? <PassAuth title={this.state.meetname} roomid={this.state.roomId}></PassAuth>
                            : <Roomi host={false} title={this.state.meetname} roomid={this.state.roomId}></Roomi>
                        : <div>You Are Not Allowed</div>
                    : this.state.auth ? <PassAuth title={this.state.meetname} roomid={this.state.roomId}></PassAuth> : <Roomi title={this.state.meetname} host={false} roomid={this.state.roomId}></Roomi>

        )


    }
};
